module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loader-wrapper"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('form', {
    staticClass: "inputform",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doSearch()
      }
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licenseplate),
      expression: "licenseplate"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Indtast nummerplade..."
    },
    domProps: {
      "value": (_vm.licenseplate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.licenseplate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Søg")])])]), _vm._v(" "), (!_vm.loading && _vm.vehicleData) ? _c('div', {
    staticClass: "vehicle-header animated fadeInUp"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "make-model"
  }, [_vm._v("\n                    " + _vm._s(_vm.vehicleData.general.MaerkeTypeNavn) + "\n                    " + _vm._s(_vm.vehicleData.general.ModelTypeNavn) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "variant"
  }, [_vm._v("\n                    " + _vm._s(_vm.vehicleData.general.VariantTypeNavn) + "\n                ")])])]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.vehicleData) ? _c('div', {
    staticClass: "grid-layout animated fadeIn delay-1s"
  }, [_c('div', {
    staticClass: "main-area"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Generelt\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Model årgang")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.general.ModelAar) ? _c('span', [_vm._v(_vm._s(_vm.vehicleData.general.ModelAar))]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Indregistreret")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.general.FoersteRegistreringDato) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.vehicleData.general.FoersteRegistreringDato, 'D[.] MMMM YYYY')))]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Art")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.general.KoeretoejArtNavn) ? _c('span', [_vm._v(_vm._s(_vm.vehicleData.general.KoeretoejArtNavn))]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Stelnummer")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.general.StelNr) ? _c('span', [_vm._v(_vm._s(_vm.vehicleData.general.StelNr))]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.general.Status) ? _c('span', [_vm._v(_vm._s(_vm.vehicleData.general.Status))]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Nuværende ejer")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.general.currentOwner) ? _c('span', [_vm._v(_vm._s(_vm.vehicleData.general.currentOwner))]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Motor")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.general.MotorStoerrelse) ? _c('span', [_vm._v("\n                                    " + _vm._s(_vm.vehicleData.general.MotorStoerrelse) + "\n                                    (" + _vm._s(_vm.vehicleData.general.MotorSlagVolumen) + " ccm,\n                                    " + _vm._s(_vm.vehicleData.general.MotorCylinderAntal) + " cyl.,\n                                    " + _vm._s(_vm.vehicleData.general.DrivkraftTypeNavn) + ")\n                                ")]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Effekt")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.general.MotorHestekraefter) ? _c('span', [_vm._v("\n                                    " + _vm._s(_vm.vehicleData.general.MotorHestekraefter) + " HK\n                                    (" + _vm._s(_vm.vehicleData.general.MotorStoersteEffekt) + " kW)\n                                ")]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Opgivet forbrug")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.general.MotorKmPerLiter) ? _c('span', [_vm._v(_vm._s(_vm.vehicleData.general.MotorKmPerLiter) + " km/l")]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Fælge / dæk")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.general.FaelgDaek) ? _c('span', [_vm._v(_vm._s(_vm.vehicleData.general.FaelgDaek))]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Sidst synet")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.dmr.SidsteSyn) ? _c('span', [_vm._v("\n                                    " + _vm._s(_vm._f("moment")(_vm.vehicleData.dmr.SidsteSyn, 'D[.] MMMM YYYY')) + "\n                                ")]) : _c('span', [_vm._v("\n                                    Køretøjet har ikke været synet endnu\n                                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Næste syn")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.dmr.NaesteSyn) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.vehicleData.dmr.NaesteSyn, 'D[.] MMMM YYYY')))]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Afgift")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.dmr.Afgift.AfgiftDetaljer.length > 0) ? _c('span', _vm._l((_vm.vehicleData.dmr.Afgift.AfgiftDetaljer), function(afgift) {
    return (afgift.AfgiftType === 'Sum') ? _c('span', {
      key: afgift.AfgiftType
    }, [_vm._v("\n                                        " + _vm._s(afgift.Pris) + " / halvårlig\n                                    ")]) : _vm._e()
  }), 0) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Udstyr")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [(_vm.vehicleData.general.KoeretoejUdstyrSamling.length > 0) ? _c('span', _vm._l((_vm.vehicleData.general.KoeretoejUdstyrSamling), function(feature) {
    return _c('div', {
      key: feature,
      staticClass: "single-feature"
    }, [_vm._v("\n                                        " + _vm._s(feature) + "\n                                    ")])
  }), 0) : _c('span', [_vm._v("-")])])]), _vm._v(" "), (_vm.vehicleData.stats.SimilarCarsCount && _vm.vehicleData.general.ModelAar && _vm.vehicleData.general.ModelAar !== '-') ? _c('div', {
    staticClass: "line line__fw"
  }, [_vm._v("\n                            Der er "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.vehicleData.stats.SimilarCarsCount) + " ")]), _vm._v(" " + _vm._s(_vm.vehicleData.general.MaerkeTypeNavn) + " " + _vm._s(_vm.vehicleData.general.ModelTypeNavn)), (_vm.vehicleData.general.ModelAar && _vm.vehicleData.general.ModelAar !== '-') ? _c('span', [_vm._v(", årgang " + _vm._s(_vm.vehicleData.general.ModelAar) + " ")]) : _vm._e(), _vm._v("indregistreret i DK\n                        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Gæld / Bilbogen\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [(_vm.vehicleData.registry.LaaneDokumenter.length === 0) ? _c('div', [_vm._v("\n                            Der er ikke registreret gæld i køretøjet\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.vehicleData.registry && _vm.vehicleData.registry.LaaneDokumenter.length > 0) ? _c('div', [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Hvem skylder")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_vm._v("\n                                    " + _vm._s(_vm.vehicleData.registry.LaaneDokumenter[0].Debitorer[0].Navn) + "\n                                    "), _c('br'), _vm._v("\n                                    CPR: " + _vm._s(_vm.vehicleData.registry.LaaneDokumenter[0].Debitorer[0].FoedselsDato) + " (XX år)\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Stelnummer")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_vm._v("\n                                    " + _vm._s(_vm.vehicleData.general.StelNr) + "\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Oprindelige lån")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_vm._v("\n                                    " + _vm._s(_vm.vehicleData.registry.LaaneDokumenter[0].HovedStol) + "\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Kreditor")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_vm._v("\n                                    " + _vm._s(_vm.vehicleData.registry.LaaneDokumenter[0].Underpanthaver) + "\n                                ")])]), _vm._v(" "), (_vm.vehicleData.registry.LaaneDokumenter[0].Underpanthaver) ? _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Bemærkninger")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, _vm._l((_vm.vehicleData.registry.LaaneDokumenter[0].TillaegsTekster), function(attention) {
    return _c('div', [_vm._v("\n                                        " + _vm._s(attention) + "\n                                    ")])
  }), 0)]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Økonomi / beregner\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._v("\n                        Antagelser: 11 kr. per liter benzin\n                        "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "line line__df"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Antal km om året")]), _vm._v(" "), _c('div', {
    staticClass: "line__val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calculator.kmPerYear),
      expression: "calculator.kmPerYear"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "150000"
    },
    domProps: {
      "value": (_vm.calculator.kmPerYear)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.calculator, "kmPerYear", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line line__df"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Service / reparation pr. 100 km")]), _vm._v(" "), _c('div', {
    staticClass: "line__val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calculator.expensePerHundredKm),
      expression: "calculator.expensePerHundredKm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": (_vm.calculator.expensePerHundredKm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.calculator, "expensePerHundredKm", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line line__df"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Evt. afbetaling pr. måned")]), _vm._v(" "), _c('div', {
    staticClass: "line__val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calculator.payoff),
      expression: "calculator.payoff"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100000"
    },
    domProps: {
      "value": (_vm.calculator.payoff)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.calculator, "payoff", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line line__df"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Forsikring pr. år")]), _vm._v(" "), _c('div', {
    staticClass: "line__val"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calculator.insurance),
      expression: "calculator.insurance"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100000"
    },
    domProps: {
      "value": (_vm.calculator.insurance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.calculator, "insurance", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "line line__df"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Afbetaling")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_vm._v(_vm._s(_vm.calculator.payoff) + " kr.")])]), _vm._v(" "), _c('div', {
    staticClass: "line line__df"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Forsikring")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_vm._v(_vm._s(_vm.calculator.insurance) + " kr.")])]), _vm._v("-->\n                        "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "line line__df"
  }, [_c('div', {
    staticClass: "line__title",
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("Månedlig udgift")]), _vm._v(" "), _c('div', {
    staticClass: "line__value",
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.monthlyExpense) + " kr.")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('i', [_vm._v("Beregneren tager ikke højde for afdrag på lån, service, reparationer og forsikring.")])])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Synsrapporter\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._l((_vm.vehicleData.inspection.Rapporter), function(report) {
    return (_vm.vehicleData && _vm.vehicleData.inspection.Rapporter) ? _c('div', {
      staticClass: "line"
    }, [_c('div', {
      staticClass: "line__title"
    }, [_vm._v(_vm._s(report.Synsdato))]), _vm._v(" "), _c('div', {
      staticClass: "line__value"
    }, [_vm._v("\n                                " + _vm._s(report.Synsresultat) + "\n                                "), _c('br'), _vm._v(" "), _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_vm._v("\n                                    Vis synsrapport\n                                ")]), _vm._v(" "), (_vm.showInspectionReportModal && _vm.inspectionReport !== null) ? _c('div', {
      staticClass: "inspection-report"
    }, [_c('div', {
      staticClass: "inner"
    }, [_c('div', {
      staticClass: "header"
    }, [_c('div', {
      staticClass: "result"
    }, [_vm._v("\n                                                " + _vm._s(_vm.inspectionReport.Synsresultat) + "\n                                            ")]), _vm._v(" "), _c('div', {
      staticClass: "company"
    }, [_c('b', [_vm._v(_vm._s(_vm.inspectionReport.Firma))]), _vm._v(" "), _c('br'), _vm._v("\n                                                " + _vm._s(_vm.inspectionReport.Adresse) + "\n                                                "), _c('br'), _vm._v("\n                                                CVR: " + _vm._s(_vm.inspectionReport.Cvr) + "        \n                                            ")])]), _vm._v(" "), _c('div', {
      staticClass: "boxes"
    }, [_c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "box__title"
    }, [_vm._v("\n                                                    Synsdato\n                                                ")]), _vm._v(" "), _c('div', {
      staticClass: "box__value"
    }, [_vm._v("\n                                                    " + _vm._s(_vm._f("moment")(_vm.inspectionReport.Synsdato, 'D[.] MMMM YYYY')) + "\n                                                ")])]), _vm._v(" "), _c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "box__title"
    }, [_vm._v("\n                                                    Synstype\n                                                ")]), _vm._v(" "), _c('div', {
      staticClass: "box__value"
    }, [_vm._v("\n                                                    " + _vm._s(_vm.inspectionReport.Synstype) + "\n                                                ")])]), _vm._v(" "), _c('div', {
      staticClass: "box"
    }, [_c('div', {
      staticClass: "box__title"
    }, [_vm._v("\n                                                    Nummerplade\n                                                ")]), _vm._v(" "), _c('div', {
      staticClass: "box__value"
    }, [_vm._v("\n                                                    " + _vm._s(_vm.inspectionReport.RegNr) + "\n                                                ")])]), _vm._v(" "), _vm._m(6, true)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Fejl")]), _vm._v(" "), (_vm.inspectionReport.Fejl.length > 0) ? _c('div', {
      staticClass: "error-wrapper"
    }, _vm._l((_vm.inspectionReport.Fejl), function(error) {
      return _c('div', {
        staticClass: "error"
      }, [_c('b', [_vm._v(_vm._s(error.Number))]), _vm._v("\n                                                " + _vm._s(error.Description) + "\n                                            ")])
    }), 0) : _c('div', [_vm._v("\n                                            Ingen fejl registreret.\n                                        ")])])]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), (_vm.vehicleData.inspection.Rapporter.length === 0) ? _c('div', [_vm._v("\n                            Køretøjet har ikke været synet endnu\n                        ")]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Afgifter\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [(_vm.vehicleData.dmr.Afgift.OpkraevedeAfgifter.length > 0) ? _c('div', {
    staticClass: "table"
  }, [_c('table', [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.vehicleData.dmr.Afgift.OpkraevedeAfgifter), function(afgift) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(afgift.RegNr))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(afgift.AfgiftType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(afgift.DaekkerFra) + " - " + _vm._s(afgift.DaekkerTil))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(afgift.Pris))])])
  }), 0)])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-area"
  }, [(_vm.vehicleData && _vm.vehicleData.general.RegNr === 'AL52114') ? _c('img', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "30px",
      "border-radius": "5px",
      "box-shadow": "0px 5px 15px rgba(0,0,0,0.15)"
    },
    attrs: {
      "src": "https://www.nummerplade.net/apps/nummerplade/carimage/8848406975.jpg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vehicleData && _vm.vehicleData.general.RegNr === 'BP59902') ? _c('img', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "30px",
      "border-radius": "5px",
      "box-shadow": "0px 5px 15px rgba(0,0,0,0.15)"
    },
    attrs: {
      "src": "/static/xsr700.jpeg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.vehicleData && _vm.vehicleData.general.RegNr !== 'AL52114' && _vm.vehicleData.general.RegNr !== 'BP59902') ? _c('img', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "30px",
      "border-radius": "5px",
      "box-shadow": "0px 5px 15px rgba(0,0,0,0.15)"
    },
    attrs: {
      "src": 'https://placehold.it/1200x799?text=' + _vm.vehicleData.general.MaerkeTypeNavn + ' ' + _vm.vehicleData.general.ModelTypeNavn + ' ' + _vm.vehicleData.general.VariantTypeNavn
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Hurtigt tjek\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "single-check"
  }, [(_vm.vehicleData.registry.LaaneDokumenter.length > 0) ? _c('div', {
    staticClass: "inner bad"
  }, [_c('i', {
    staticClass: "fas fa-exclamation fa-fw"
  }), _vm._v("\n                                Der er registreret pant i køretøjet!\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.vehicleData.general.LeasingPeriode) ? _c('div', {
    staticClass: "inner neutral"
  }, [_c('i', {
    staticClass: "fas fa-info fa-fw"
  }), _vm._v("\n                                Køretøjet er leaset\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.vehicleData.registry.LaaneDokumenter.length === 0 && !_vm.vehicleData.general.LeasingPeriode) ? _c('div', {
    staticClass: "inner good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v("\n                                Der er ikke registreret pant i køretøjet\n                            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "single-check"
  }, [(_vm.vehicleData.inspection.Rapporter.length > 0 && _vm.vehicleData.inspection.Rapporter[0].Synsresultat === 'Godkendt') ? _c('div', {
    staticClass: "inner good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v("\n                                Køretøjet bestod seneste syn\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.vehicleData.inspection.Rapporter.length > 0 && _vm.vehicleData.inspection.Rapporter[0].Synsresultat !== 'Godkendt') ? _c('div', {
    staticClass: "inner bad"
  }, [_c('i', {
    staticClass: "fas fa-exclamation fa-fw"
  }), _vm._v("\n                                Køretøjet bestod ikke seneste syn\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.vehicleData.inspection.Rapporter.length === 0) ? _c('div', {
    staticClass: "inner good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v("\n                                Køretøjet har ikke været synet endnu\n                            ")]) : _vm._e()]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "single-check"
  }, [(_vm.vehicleData.dmr.Forsikring.Status === 'Aktiv') ? _c('div', {
    staticClass: "inner good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v("\n                                Køretøjet er forsikret\n                            ")]) : _c('div', {
    staticClass: "inner bad"
  }, [_c('i', {
    staticClass: "fas fa-exclamation fa-fw"
  }), _vm._v("\n                                Køretøjet er ikke forsikret\n                            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                        Forsikring\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_vm._v(_vm._s(_vm.vehicleData.dmr.Forsikring.Status))])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Selskab")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_vm._v(_vm._s(_vm.vehicleData.dmr.Forsikring.Selskab))])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Oprettet")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.vehicleData.dmr.Forsikring.Oprettet, 'D[.] MMMM YYYY')))])])])])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lds-ring"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('i', {
    staticClass: "fal fa-car fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Forsikring")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_c('a', {
    attrs: {
      "href": "https://www.partner-ads.com/dk/klikbanner.php?partnerid=28784&bannerid=60068&htmlurl=https://www.findforsikring.dk/indhent-tilbud-mini/?bil1=on"
    }
  }, [_vm._v("Se forsikringspriser her")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Finansiering")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("Se oversigt over lånemuligheder")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line line__df"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Brændstof")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_vm._v("667 kr.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line line__df"
  }, [_c('div', {
    staticClass: "line__title"
  }, [_vm._v("Service / reparation")]), _vm._v(" "), _c('div', {
    staticClass: "line__value"
  }, [_vm._v("379 kr.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v("\n                                                    Kilometerstand\n                                                ")]), _vm._v(" "), _c('div', {
    staticClass: "box__value"
  }, [_vm._v("\n                                                    203.000 km\n                                                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Reg.nr.")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Dækker fra/til")]), _vm._v(" "), _c('th', [_vm._v("Beløb")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "single-check"
  }, [_c('div', {
    staticClass: "inner good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v("\n                                Køretøjet er ikke efterlyst\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "single-check"
  }, [_c('div', {
    staticClass: "inner good"
  }, [_c('i', {
    staticClass: "fas fa-check fa-fw"
  }), _vm._v("\n                                Ingen tegn på kilometerfusk\n                            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94c7567a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/index.vue
// module id = 357
// module chunks = 1